/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { Div } from '@certilogo/design-system-web';
import { addCssProp } from '@certilogo/design-system-web/dist/shared/styles';

export const Wrapper = styled(Div)`
  ${addCssProp}
`;
